import React, { useEffect } from "react";
import { Outlet, useParams, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { isLang } from "@/lib/helpers";

export function PublicLayout() {
  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (lang && isLang(lang)) {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang;
    }
  }, [lang, i18n]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  if (!isLang(lang)) {
    return <Navigate to="/en" replace />;
  }

  return (
    <div className="App bg-bg min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-cyan focus:text-ink-900 focus:px-4 focus:py-2 focus:font-display focus:uppercase"
      >
        {t("common.skipToContent")}
      </a>
      <Header />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
